'use client'

import { useEffect } from 'react'

export default function ScrollbarAutoHide() {
  useEffect(() => {
    let scrollTimer: NodeJS.Timeout | null = null

    const handleScroll = () => {
      // Add scrolling class when scrolling starts
      document.documentElement.classList.add('scrolling')
      
      // Clear existing timer
      if (scrollTimer) {
        clearTimeout(scrollTimer)
      }
      
      // Set timer to remove scrolling class after scrolling stops
      scrollTimer = setTimeout(() => {
        document.documentElement.classList.remove('scrolling')
      }, 1000) // Hide scrollbar 1 second after scrolling stops
    }

    // Add scroll event listener
    window.addEventListener('scroll', handleScroll, { passive: true })

    // Cleanup
    return () => {
      window.removeEventListener('scroll', handleScroll)
      if (scrollTimer) {
        clearTimeout(scrollTimer)
      }
    }
  }, [])

  return null // This component doesn't render anything
}

